/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { useSignupData } from '../signup-data/useSignupData';
import { Data } from 'signup-constants/signupData/Data';
export const useOldSignupEmail = () => {
  const {
    data: email
  } = useSignupData(Data.Email);
  const [oldEmail, setOldEmail] = useState('');
  const mount = () => {
    setOldEmail(email);
  };
  useEffect(mount, []);
  return {
    oldEmail
  };
};